import React from 'react';
import ShoppingCart, { CartProvider } from './components/ShoppingCart';
import { StoreHeader, StoreFooter } from './components/StoreChrome';
export default function CartPage() {
 return <CartProvider><div className="cart-store"><a className="skip-link" href="#main">Skip to content</a><StoreHeader cartPage/><main id="main" className="cart-page"><ShoppingCart/></main><StoreFooter/></div></CartProvider>;
}
